import { Model } from "@vuex-orm/core";
import Customer from "./Customer";
import User from "./User";
import Address from "./Address";
import ContactInfo from "./ContactInfo";
import ListItem from "./ListItem";

export default class Appointment extends Model {
  static entity = "appointments";

  static fields() {
    return {
      createdAt: this.attr(),
      updatedAt: this.attr(),
      id: this.attr(),
      isDirty: this.boolean(false),
      customerId: this.number(),
      jobTypeId: this.number(),
      addressId: this.number(),
      contactInfoId: this.number(),
      serviceEmployeeId: this.number(),
      note: this.attr(),
      startTime: this.attr(),
      endTime: this.attr(),
      travelStartTime: this.attr(),
      customer: this.belongsTo(Customer, "customerId"),
      serviceEmployee: this.belongsTo(User, "serviceEmployeeId"),
      address: this.belongsTo(Address, "addressId"),
      contactInfo: this.belongsTo(ContactInfo, "contactInfoId"),
      jobType: this.belongsTo(ListItem, "jobTypeId")
    };
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      startTime(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      endTime(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      travelStartTime(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
